module.exports = __webpack_public_path__ + "img/36.3ed8f91e.svg";